<template lang="html">
    <div id="">
        <navbar v-if="!$route.meta.hideNavbar"></navbar>
        <router-view></router-view>
    </div>
</template>

<script>
import NavBar from "@/components/navbar-admin.vue";
export default {
    name: "app",
    components: {
        navbar: NavBar
    },
};
</script>
